import { Pipe, PipeTransform } from '@angular/core';
import * as qs from 'qs';

import { NavigationMenu } from '../domain/entities/side-nav-items';

export interface SubMenuActive {
  isActive: boolean;
  timeStamp: string;
}

@Pipe({
  name: 'isSubMenuOpen',
  standalone: true,
})
export class IsSubMenuOpenPipe implements PipeTransform {
  transform(navItem: NavigationMenu, currentUrl: string): boolean {
    // root url '/'
    if (currentUrl.length <= 1) {
      return false;
    }

    const childLinks = navItem.children.map((c) => (!c.queryParams ? c.link : `${c.link}?${qs.stringify(c.queryParams)}`)) ?? [];
    const childPaths = navItem.children
      .filter((c) => c.pathsInArea?.length)
      .map((c) => c.pathsInArea ?? [])
      .reduce((accum, curr) => accum.concat(curr), [] as string[]);
    const navPaths = navItem.pathsInArea ?? [];

    return [...childLinks, ...childPaths, ...navPaths].some((p) => currentUrl.match(p)?.length || currentUrl === p);
  }
}
